import Vue from "vue";
import store from "@/store";
import VueRouter from "vue-router";
import Queues from "./queues";
import MedicalRecord from "./medical_record";
import Patient from "./patient";
import AttendancesList from "./attendances_list";
import Config from "./config";
import PatientZone from "./patient_zone";

import Home from "@/views/Home.vue";
import Login from "@/views/login.vue";
import ResetPassword from "@/views/reset_password.vue";
import PatientLogin from "@/views/patient_login.vue";
import PatientScreen from "@/views/patient/index.vue";
import ChangePassword from "@/views/change_password.vue";

import { hasPendingSubmissionsHook } from "@/router/hooks/beforeEach/hasPendingSubmissions.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: {
      path: "/filas",
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { requiresAuth: false, title: "Login" },
  },

  {
    path: "/reset-password",
    name: "Resetar Senha",
    component: ResetPassword,
    meta: { requiresAuth: false, title: "Login" },
  },
  {
    path: "/paciente-login",
    name: "Paciente login",
    component: PatientLogin,
    meta: { requiresAuth: false, title: "Login" },
  },
  {
    path: "/paciente",
    name: "Area do paciente",
    component: PatientScreen,
    meta: { patientRoute: true, title: "Paciente" },
    redirect: {
      path: "/paciente/atestados",
    },
    children: PatientZone,
  },
  {
    path: "/trocar_senha/:token",
    name: "Trocar senha",
    component: ChangePassword,
    props: true,
    meta: { requiresAuth: false, title: "Trocar senha" },
  },
].concat(Queues, MedicalRecord, Patient, Config, AttendancesList);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth === false) {
    next();
  } else {
    if (store.state.authentication.token) {
      let tokenPayload = store.getters["authentication/tokenPayload"];

      if (tokenPayload.userable_type === "patient") {
        if (to.meta.patientRoute === true) {
          return next();
        } else {
          store.dispatch("createNotification", {
            message: "Você não tem permissão para acessar essa rota.",
            type: "error",
          });

          return next("/paciente");
        }
      }

      if (tokenPayload.userable_type === "employee") {
        if (to.meta.patientRoute === true) {
          store.dispatch("createNotification", {
            message: "Você não tem permissão para acessar essa rota.",
            type: "error",
          });

          return next({ path: "/" });
        } else {
          return next();
        }
      }

      next();
    } else {
      next({ name: "login" });
    }
  }
});

router.beforeEach(hasPendingSubmissionsHook);

router.afterEach((to) => {
  let pageTitle = "Eaglesoft";
  pageTitle += to.meta.title ? ` - ${to.meta.title}` : "";

  document.title = pageTitle;
});

export default router;
